module.exports = __webpack_public_path__ + "img/motor_no40.c121c48d.jpg";